module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-01-7746d4216c4cacb0fcec5a4075dc4929.png";